"use strict";
/*
 * Created on 08 13 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProductFlag_1 = require("./ProductFlag");
/**
 * @author Jaroslav Sevcik
 *
 * Subset of product data selected mainly for data management pages (pairing, cleaning, price architecture).
 */


var ProductInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductInfo, _DomainObject_1$Domai);

  /**
   * @param id the internal id of product
   * @param externalId the external id of product, i.e. from source data, is used for pairing during data import
   * @param name
   * @param familyId reference to family to which product belong, it is here for query optimization (information about products in family
   *        is mainly part of FamilyBinding of Family)
   * @param categoryIds List of product categories. The first one is lowest category, the last one is root.
   * @param productSensitivityId
   * @param tierId Tier assigned to product.
   * @param flags
   * @param supplierId id of preferred supplier within national zone (null means no preferred supplier has been found, most probably
   *        product has no suppliers)
   * @param measureUnitId which cannot be changed in time. If not otherwise stated, all data (such as within transactions,
   *        supplies, ...) are related to this unit.
   * @param packageSize weight/volume for unit price calculation
   *        first pairing
   */
  function ProductInfo(id, externalId, name, familyId, categoryIds, productSensitivityId, tierId, flags, supplierId, measureUnitId, packageSize) {
    var _this;

    _classCallCheck(this, ProductInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductInfo).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.familyId = familyId;
    _this.categoryIds = categoryIds;
    _this.productSensitivityId = productSensitivityId;
    _this.tierId = tierId;
    _this.flags = flags;
    _this.supplierId = supplierId;
    _this.measureUnitId = measureUnitId;
    _this.packageSize = packageSize;
    return _this;
  }
  /**
   * Creates an instance of {@link ProductInfo product info} from a {@link Product product}.
   *
   * @param product
   */


  _createClass(ProductInfo, null, [{
    key: "createProductInfo",
    value: function createProductInfo(product) {
      return new ProductInfo(product.id, product.externalId, product.name, product.familyId, product.categoryIds, product.productSensitivityId, product.tierId, product.flags, product.supplierId, product.measureUnitId, product.packageSize);
    }
  }]);

  return ProductInfo;
}(DomainObject_1.DomainObject);

exports.ProductInfo = ProductInfo;

ProductInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductInfo.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    name: builder.str('name'),
    familyId: builder.opt(builder.str('familyId')),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    flags: builder.flags('flags', ProductFlag_1.ProductFlag),
    productSensitivityId: builder.opt(builder.str('productSensitivityId')),
    tierId: builder.opt(builder.id('tierId')),
    supplierId: builder.opt(builder.id('supplierId')),
    measureUnitId: builder.id('measureUnitId'),
    packageSize: builder.data('packageSize', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })
  };
}();